// src/pages/PrimarySubject.jsx
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function PrimarySubject() {
  const { classId, subject } = useParams();
  const navigate = useNavigate();

  const chapters = Array.from({ length: 5 }, (_, i) => ({
    id: `chapter${i + 1}`,
    name: `Chapter ${i + 1}`,
  }));

  return (
    <div className="min-h-screen p-6 bg-yellow-50">
      <h1 className="text-3xl font-bold mb-6 text-center">
        {subject.toUpperCase()}
      </h1>

      <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
        {chapters.map((ch) => (
          <div
            key={ch.id}
            onClick={() =>
              navigate(`/primary/${classId}/${subject}/${ch.id}`)
            }
            className="bg-white p-6 rounded-xl shadow cursor-pointer hover:shadow-lg transition"
          >
            <h2 className="text-xl font-semibold text-center">
              {ch.name}
            </h2>
          </div>
        ))}
      </div>
    </div>
  );
}
